export default __webpack_public_path__ + "static/media/assets-news.e833e919.png";